var exports = {
  "iE": "xaee3c4fa--131fcd--wrapper",
  "$0": "xaee3c4fa--131fcd--title-wrapper",
  "s6": "xaee3c4fa--131fcd--rubric-wrapper",
  "DD": "xaee3c4fa--131fcd--title",
};

module.exports = exports;
